module.exports = __webpack_public_path__ + "media/images/frontend/btn_red_bg-1465f55814d6007849305bc45a2e6abc.svg";